import { render, staticRenderFns } from "./CopiesModal.vue?vue&type=template&id=063dbaac&scoped=true"
import script from "./CopiesModal.vue?vue&type=script&lang=js"
export * from "./CopiesModal.vue?vue&type=script&lang=js"
import style0 from "./CopiesModal.vue?vue&type=style&index=0&id=063dbaac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dbaac",
  null
  
)

export default component.exports